<template>
    <router-view />
</template>

<script>
export default {
    name: "Talimat"
}
</script>

<style scoped></style>